import React, { useState, useEffect, Suspense } from "react";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import { Collapse } from "@mui/material";
import { ExpandLess, ExpandMore, SignalCellularAltOutlined } from "@mui/icons-material";
import axios from "axios";
import {
  Box,
  CssBaseline,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  IconButton,
  useMediaQuery,
  Drawer,
  Popover
} from "@mui/material";
import {
  AddBoxOutlined,
  Menu,
  Dashboard,
  CalendarMonthOutlined,
  History,
  Gavel,
  Logout
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { toast } from "react-toastify";
import { resetContact } from "../../redux/reducers/contactReducer";
import { resetHomeRe } from "../../redux/reducers/homeReducer";
import { useDispatch, useSelector } from "react-redux";
import { reset } from "../../redux/reducers/login";
import { paths } from "../../config/constants";
import { PageLoading } from "../../component/includes/PageLoading";
import { logoutUser } from "../../component/Elements/Session";
import useSessionTimeout from "../Elements/useSessionTimeout";
const drawerWidthExpanded = 240;
const drawerWidthCollapsed = 70;

const SidebarContainer = styled(Box)(({ collapsed }) => ({
  width: collapsed ? drawerWidthCollapsed : drawerWidthExpanded,
  backgroundColor: "#0E4672",
  color: "#fff",
  display: "flex",
  flexDirection: "column",
  overflowX: "hidden",
  height: "100%"
}));

const StyledItem = styled(ListItemButton)(({ active }) => ({
  padding: "12px 20px",
  color: "#fff",
  borderLeft: active ? "4px solid #f16729" : "4px solid transparent",
  backgroundColor: active ? "#293846" : "transparent",
  "&:hover": {
    backgroundColor: "#293846",
    color: "#fff"
  }
}));

/* ================= SIDEBAR ================= */

function SidebarContent({ collapsed, role }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useSessionTimeout();
  const location = useLocation();

  const [openTermsAndPolicies, setOpenTermsAndPolicies] = useState(false);
  const [termsAndPolicyAnchor, setTermsAndPolicyAnchor] = useState(null); // ✅ ADD THIS
  const [companyActiveStatus,setCompanyActiveStatus] = useState(null);
  const [empActiveStatus,setEmpActiveStatus] = useState(null);
  const reduxdata = useSelector((state) => state);
  const userId = reduxdata?.login?.user?.data?._id;
  let toastId1 = null;
  const handleLogout = async () => {
  await logoutUser({
    dispatch,
    navigate,
  });
};

const handleExpire = async () => {
  await logoutUser({
    dispatch,
    navigate,
    expired: true,
  });
};

  const active = location.pathname;
  const fetchUserProfileData = async () => {
    let obj = {
      userId: userId,
    };
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_URL}api/user/getUserProfile`,
          obj
        );
        fetchCompanyProfileData(res?.data?.data?.companyName)
        setEmpActiveStatus(res?.data?.data?.isUserActivated)
      } catch (error) {}
    
  };
  useEffect(() => {
    fetchUserProfileData();
  }, []);
  

  const fetchCompanyProfileData = async (employeeCompany) => {
    let obj = {
      role:"2",
      companyName:employeeCompany
    };

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}api/user/CompanyProfileData`,
        obj
      );
      setCompanyActiveStatus(res?.data?.data?.isUserActivated)
    } catch (error) {}
  };

  useEffect(() => {
    console.log("employee active status",empActiveStatus)
    console.log("Company active status",companyActiveStatus)
  }, [companyActiveStatus]);

  return (
    <SidebarContainer collapsed={collapsed}>
      {/* LOGO */}
      <Box
        onClick={() =>
          role === "Driver"
            ? navigate(paths.driver.dashboard)
            : navigate(paths.employeeUpcomingRides)
        }
        sx={{
          padding: "20px",
          display: "flex",
          justifyContent: "center",
          cursor: "pointer"
        }}
      >
        <img
          src="https://blu.taxi/static/media/BLU%20TAXI%20white%20logo.4f586d7f9285146a885b.png"
          alt="BLU TAXI"
          style={{ width: collapsed ? 40 : 140 }}
        />
      </Box>

      <List>

        {/* DRIVER MENU */}
        {role === "Driver" && (
          <>
            <StyledItem
              active={active === paths.driver.dashboard}
              onClick={() => navigate(paths.driver.dashboard)}
            >
              <ListItemIcon sx={{ color: "#fff" }}>
                <Dashboard />
              </ListItemIcon>
              {!collapsed && <ListItemText primary="Dashboard" />}
            </StyledItem>

            <StyledItem
              active={active === paths.driver.upcomingRides}
              onClick={() => navigate(paths.driver.upcomingRides)}
            >
              <ListItemIcon sx={{ color: "#fff" }}>
                <CalendarMonthOutlined />
              </ListItemIcon>
              {!collapsed && <ListItemText primary="Upcoming Rides" />}
            </StyledItem>

            <StyledItem
              active={active === paths.driver.rideReport}
              onClick={() => navigate(paths.driver.rideReport)}
            >
              <ListItemIcon sx={{ color: "#fff" }}>
                <SignalCellularAltOutlined />
              </ListItemIcon>
              {!collapsed && <ListItemText primary="Ride Report" />}
            </StyledItem>

            <StyledItem
              active={active === paths.driver.rideHistory}
              onClick={() => navigate(paths.driver.rideHistory)}
            >
              <ListItemIcon sx={{ color: "#fff" }}>
                <History />
              </ListItemIcon>
              {!collapsed && <ListItemText primary="Ride History" />}
            </StyledItem>

            <StyledItem
              active={active === paths.driver.driverTermsCondition}
              onClick={() => navigate(paths.driver.driverTermsCondition)}
            >
              <ListItemIcon sx={{ color: "#fff" }}>
                <Gavel />
              </ListItemIcon>
              {!collapsed && <ListItemText primary="Terms & Conditions" />}
            </StyledItem>
          </>
        )}

        {/* EMPLOYEE MENU */}
        {role === "Employee" && (
          <>
            <StyledItem
              active={active === paths.employeeUpcomingRides}
              onClick={() => navigate(paths.employeeUpcomingRides)}
            >
              <ListItemIcon sx={{ color: "#fff" }}>
                <CalendarMonthOutlined />
              </ListItemIcon>
              {!collapsed && <ListItemText primary="Upcoming Rides" />}
            </StyledItem>

            <StyledItem
              active={active === paths.employeeRideHistory}
              onClick={() => navigate(paths.employeeRideHistory)}
            >
              <ListItemIcon sx={{ color: "#fff" }}>
                <History />
              </ListItemIcon>
              {!collapsed && <ListItemText primary="Ride History" />}
            </StyledItem>

            <StyledItem
              active={active === paths.employeeBooking}
              // onClick={() => navigate(paths.employeeBooking)}
              onClick={(e) => {
                // Prevent navigation if emp company or employ itself is inactive
                if (companyActiveStatus != "1") {
                  e.preventDefault();
                  if (!toast.isActive(toastId1)) {
                    toastId1 = toast.info(
                      "You cannot book right now your company's profile status is inactive.",
                      { autoClose: 2500 }
                    );
                  }
                  return;
                }
                if (empActiveStatus != "1") {
                  e.preventDefault();
                  if (!toast.isActive(toastId1)) {
                    toastId1 = toast.info(
                      "You cannot book right now because your account status is inactive",
                      { autoClose: 2500 }
                    );
                  }
                  return;
                }
                navigate(paths.employeeBooking);
              }}
            >
              <ListItemIcon sx={{ color: "#fff" }}>
                <AddBoxOutlined />
              </ListItemIcon>
              {!collapsed && <ListItemText primary="Create Booking" />}
            </StyledItem>


              <StyledItem
              active={active === paths.employeeRideReport}
              onClick={() => navigate(paths.employeeRideReport)}
            >
              <ListItemIcon sx={{ color: "#fff" }}>
                <SignalCellularAltOutlined />
              </ListItemIcon>
              {!collapsed && <ListItemText primary="Ride Report" />}
            </StyledItem>

            {/* TERMS & POLICIES DROPDOWN */}
            <StyledItem
              active={
                active === paths.bookingTermsAndCond ||
                active === "/booking-terms-and-conditions"
              }
              onClick={(e) => {
                if (collapsed) {
                    setTermsAndPolicyAnchor(e.currentTarget); // popup when collapsed
                    }
                else {
                    setOpenTermsAndPolicies(!openTermsAndPolicies) // expand when open sidebar
                }
              }}
              
            >
              <ListItemIcon sx={{ color: "#fff" }}>
                <Gavel />
              </ListItemIcon>

              {!collapsed && (
                <>
                  <ListItemText primary="Terms & Policies" />
                  {openTermsAndPolicies ? <ExpandLess /> : <ExpandMore />}
                </>
              )}
            </StyledItem>

            {/* <Collapse in={openTermsAndPolicies && !collapsed} timeout="auto">
              <List component="div" disablePadding>

                <StyledItem
                  active={active === paths.bookingTermsAndCond}
                  sx={{ pl: 6 }}
                  onClick={() => navigate(paths.bookingTermsAndCond)}
                >
                  <ListItemText primary="Terms and Conditions" />
                </StyledItem>

                <StyledItem
                  active={active === paths.cancellationPolicy}
                  sx={{ pl: 6 }}
                  onClick={() =>
                    navigate("/cancellationPolicy")
                  }
                >
                  <ListItemText primary="Cancellation Policy" />
                </StyledItem>

              </List>
            </Collapse> */}
            <Collapse in={openTermsAndPolicies && !collapsed} timeout="auto">
                <List component="div" disablePadding>

                  {/* <StyledItem
                    active={active === paths.bookingTermsAndCond}
                    sx={{ pl: 6 }}
                    onClick={() => navigate(paths.bookingTermsAndCond)}
                  >
                    <ListItemText primary="Terms and Conditions" />
                  </StyledItem> */}

                  <StyledItem
                    active={active === paths.cancellationPolicy}
                    sx={{ pl: 6 }}
                    onClick={() =>
                      navigate("/cancellationPolicy")
                    }
                  >
                    <ListItemText primary="Cancellation Policy" />
                  </StyledItem>

                  <StyledItem
                    active={active === paths.employeeTermsAndCondition}
                    sx={{ pl: 6 }}
                    onClick={() => navigate(paths.employeeTermsAndCondition)}
                  >
                    <ListItemText primary="Employee Terms & Conditions" />
                  </StyledItem>

                </List>
              </Collapse>

             <Popover
              open={Boolean(termsAndPolicyAnchor)}
              anchorEl={termsAndPolicyAnchor}
              onClose={() => setTermsAndPolicyAnchor(null)}
              anchorOrigin={{
                vertical: "center",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "center",
                horizontal: "left",
              }}
              PaperProps={{
                sx: {
                  backgroundColor: "#0E4672",
                  color: "#fff",
                  borderRadius: "8px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.3)"
                }
              }}
            >
              {/* <List sx={{ minWidth: 200 }}>
            
                <ListItemButton
                  sx={{
                    color: "#fff",
                    "&:hover": { backgroundColor: "#293846" }
                  }}
                  onClick={() => { 
                    setTermsAndPolicyAnchor(null);
                    navigate(paths.bookingTermsAndCond); }}
                >
                  <ListItemText primary="Terms & Conditions" />
                </ListItemButton>
            
                <ListItemButton
                  sx={{
                    color: "#fff",
                    "&:hover": { backgroundColor: "#293846" }
                  }}
                onClick={() => { 
                  setTermsAndPolicyAnchor(null);
                  navigate(paths.cancellationPolicy); }}
                >
                  <ListItemText primary="Cancellation Policy" />
                </ListItemButton>
            
              </List> */}
             <List sx={{ minWidth: 200 }}>

                {/* <ListItemButton
                  sx={{
                    color: "#fff",
                    "&:hover": { backgroundColor: "#293846" }
                  }}
                  onClick={() => { 
                    setTermsAndPolicyAnchor(null);
                    navigate(paths.bookingTermsAndCond); }}
                >
                  <ListItemText primary="Terms & Conditions" />
                </ListItemButton> */}

                <ListItemButton
                  sx={{
                    color: "#fff",
                    "&:hover": { backgroundColor: "#293846" }
                  }}
                onClick={() => { 
                  setTermsAndPolicyAnchor(null);
                  navigate(paths.cancellationPolicy); }}
                >
                  <ListItemText primary="Cancellation Policy" />
                </ListItemButton>

                <ListItemButton
                  sx={{
                    color: "#fff",
                    "&:hover": { backgroundColor: "#293846" }
                  }}
                  onClick={() => { 
                    setTermsAndPolicyAnchor(null);
                    navigate(paths.employeeTermsAndCondition); }}
                >
                  <ListItemText primary="Employee Terms & Conditions" />
                </ListItemButton>

                </List>
            </Popover>
          </>
        )}

        {/* LOGOUT */}
        <StyledItem onClick={handleLogout}>
          <ListItemIcon sx={{ color: "#ff4d4f" }}>
            <Logout />
          </ListItemIcon>
          {!collapsed && (
            <ListItemText primary="Logout" sx={{ color: "#ff4d4f" }} />
          )}
        </StyledItem>

      </List>
    </SidebarContainer>
  );
}

/* ================= MAIN LAYOUT ================= */

export default function DriverEmployeeLayout() {
  const isMobile = useMediaQuery("(max-width:600px)");
  const isTablet = useMediaQuery("(min-width:601px) and (max-width:1024px)");
  const isLaptopOrAbove = useMediaQuery("(min-width:1025px)");

  const username = localStorage.getItem("userName");
  const accountType = localStorage.getItem("accountType"); // 'Driver' or 'Employee'
  const userId = localStorage.getItem("userID");
const [termsAndPolicyAnchor, setTermsAndPolicyAnchor] = useState(null);

  const [collapsed, setCollapsed] = useState(false);
  const [mobileCollapsed, setMobileCollapsed] = useState(true);

  const handleMenuClick = () => {
    if (isMobile || isTablet) {
      setMobileCollapsed((prev) => !prev);
    } else {
      setCollapsed((prev) => !prev);
    }
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <CssBaseline />

      {/* DESKTOP SIDEBAR */}
      {isLaptopOrAbove && (
        <Box sx={{ width: collapsed ? drawerWidthCollapsed : drawerWidthExpanded }}>
          <SidebarContent collapsed={collapsed} role={accountType} />
        </Box>
      )}

      {/* MOBILE DRAWER */}
      {(isMobile || isTablet) && (
        <Drawer
          variant="temporary"
          open={!mobileCollapsed}
          onClose={() => setMobileCollapsed(true)}
          ModalProps={{ keepMounted: true }}
          sx={{
            "& .MuiDrawer-paper": { width: drawerWidthExpanded, backgroundColor: "#0E4672" }
          }}
        >
          <SidebarContent collapsed={false} role={accountType} />
        </Drawer>
      )}

      {/* MAIN CONTENT */}
      <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", minWidth: 0 }}>
        {/* HEADER */}
        <Box
          sx={{
            height: 60,
            backgroundColor: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 3,
            borderBottom: "1px solid #e5e5e5",
            position: "relative"
          }}
        >
          <IconButton
            onClick={handleMenuClick}
            sx={{ backgroundColor: "#f16729", color: "#fff", "&:hover": { backgroundColor: "#f16729" } }}
          >
            <Menu />
          </IconButton>

          {/* DASHBOARD TITLE */}
          {!isMobile && (
            <Box
              sx={{
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
                fontWeight: 600,
                fontSize: 16
              }}
            >
              {accountType} Dashboard
            </Box>
          )}

          {/* USER */}
          <Box sx={{ textAlign: "right", mr: { xs: 3, sm: 5, md: 0 } }}>
            <Box sx={{ fontSize: 15, fontWeight: 600 }}>{username}</Box>
            <Box sx={{ fontSize: 14 }}>ID: {userId}</Box>
          </Box>
        </Box>

        {/* PAGE CONTENT */}
       <Box
  component="main"
  sx={{
    flexGrow: 1,
    backgroundColor: "#f3f3f4",
    px: { xs: 2, sm: 3, md: 4 },
    py: 3,
    width: "100%",
    overflowX: "hidden"
  }}
>
  <Suspense fallback={<PageLoading />}>
    <Outlet />
  </Suspense>
</Box>
      </Box>
    </Box>
  );
}